  document.addEventListener('DOMContentLoaded', async () => {

    const grid = document.getElementById('wishlist-grid');
    const storageKey = 'shopify_wishlist';
    const savedHandles = JSON.parse(localStorage.getItem(storageKey)) || [];

    // Safely parse the array of stored product handles from browser LocalStorage; fallback to an empty array if null
    document.getElementById('wishlist-loading')?.remove();

    // EMPTY STATE GUARD: If no handles are stored, alter the layout visibility state and halt execution
    if (savedHandles.length === 0) {
      document.getElementById('wishlist-empty').style.display = 'block';
      return;
    }

    // ASYNCHRONOUS PROCESSING LOOP: Sequentially iterate over each unique saved product handle
    for (const handle of savedHandles) {
      try {

        const response = await fetch(`/products/${handle}?view=card`);
        if (!response.ok) continue;
        
        const html = await response.text();
        if (html.trim() === '') continue;

        const itemContainer = document.createElement('div');
        itemContainer.className = 'wishlist-grid-item';
        itemContainer.innerHTML = html;

        // Mount the newly populated card module element directly into the live display grid container
        grid.appendChild(itemContainer);

        
      } catch (err) {
        console.error("Error loading wishlist item:", err);
      }
    }

    let wishlist = savedHandles;

    const wishlistButtons = document.querySelectorAll('.wishlist-btn');

     wishlistButtons.forEach(btn => {

        btn.addEventListener('click', (e) => {

          e.preventDefault();

          const handle = btn.getAttribute('data-wishlist-handle');

          const parentCard = btn.closest('.wishlist-grid-item');

           Swal.fire({
              title: '¿Quieres quitar este producto?',
              html: 'Ya no estará guardado en tu lista  de favoritos para compras futuras.',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Si, eliminar',
              cancelButtonText: 'Cancelar',
              confirmButtonColor: '#212529', 
              cancelButtonColor: '#6c757d'
          }).then(result => {

              if (result.isConfirmed) {

                  if (wishlist.includes(handle)) {
                    // Remove item
                    wishlist = wishlist.filter(item => item !== handle);
                    btn.classList.remove('is-active');

                  } else {
                    // Add item
                    wishlist.push(handle);
                    btn.classList.add('is-active');
                  }
              
                  // If the parent card element is found in the DOM, delete it completely and update wishlist item on local storage
                  if (parentCard) {
                    
                      parentCard.remove();

                      localStorage.setItem(storageKey, JSON.stringify(wishlist));

                      if (wishlist.length === 0) {
                      
                        document.getElementById('wishlist-empty').style.display = 'block';

                      }
          
                  }    
      
                }

          });      
      
        });
        
    });

  });